import { GrMapLocation, GrPowerReset } from "react-icons/gr";
import { CiFilter } from "react-icons/ci";
import { FaUser, FaFile, FaWallet } from "react-icons/fa";
import { MdOutlineInventory2 } from "react-icons/md";
import { TbBuildingFactory, TbFileInvoice } from "react-icons/tb";
import { IoMdCopy } from "react-icons/io";

import { TiMap } from "react-icons/ti";
import { MdOutlineFileUpload } from "react-icons/md";
import { ImCross } from "react-icons/im";
import { FiPackage } from "react-icons/fi";

export const APP_NAME = "Unicharm";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const IMAGE_BASE_URL = "https://unicharm.s3.ap-south-1.amazonaws.com/";

export const EXPORT_FILE_TYPES = {
  MATERIALS: 1,
  PURCHASE_GRN: 2,
  RETAILERS: 3,
  INVENTORY_DETAILS: 4,
  SALES_PROPOSAL: 5,
  SALES_ORDERS: 6,
  SALES_INVOICES: 7,
  RETAILER_INVOICES_BILLING: 8,
  BOTREE_INVOICES: 9,
  CANCEL_INVOICE: 10,
  RETURN_INVOICE: 11,
  RETAILER_AR: 12,
  PAYMENTS: 13,
  ADVANCE_PAYMENTS: 14,
  INVENTORY_LOGS: 15,
  PENDING_PAYMENTS_INVOICE: 16,
  ADVANCE_PAYMENTS_LOGS: 17,
  RETURN_PURCHASE_GRN: 18,
  PRICE_PURCHASE_DIFFERENCE: 19,
  EXPORT_GROUPED_SALES_INVOICES: 20,
  STOCK_SUMMARY: 21,
  BULK_UPLOAD_ERROR: 22,
  DEBIT_CREDIT_NOTES: 23,
};

export const IMPORT_FILE_TYPES = {
  INVENTORY_UPDATE: 1,
}

export const CUSTOMER_GROUP = [
  { label: "A01", value: "SS-Super Stockist" },
  { label: "A02", value: "TT-Traditional Trade" },
  { label: "A03", value: "MT-Modern Trade" },
  { label: "A04", value: "Hospital MT" },
  { label: "A05", value: "SDB MT" },
  { label: "A06", value: "SDB TT" },
  { label: "A07", value: "Amazon" },
  { label: "A08", value: "Reliance C&C" },
  { label: "A09", value: "Bharti" },
  { label: "A10", value: "SDB TT Jodhpur" },
  { label: "A11", value: "Walmart" },
  { label: "A12", value: "Cloudtail" },
  { label: "A13", value: "CPC" },
  { label: "A14", value: "CSD Rest of India" },
  { label: "A15", value: "Reliance Retail" },
  { label: "A16", value: "Metro" },
  { label: "A17", value: "TNPC" },
  { label: "A18", value: "UPGC" },
  { label: "A19", value: "CSR" },
  { label: "A20", value: "Export-UCIa:Grp comp" },
  { label: "A21", value: "Export-UCIa:Others" },
  { label: "A22", value: "Other Customers" },
  { label: "A23", value: "Plants for STO" },
  { label: "A24", value: "Urban SS" },
  { label: "A25", value: "USS Madurai" },
  { label: "A26", value: "CSD Bhiwandi" },
  { label: "A27", value: "SDB TT Zirakpur" },
  { label: "A28", value: "SDB MT Zirakpur" },
  { label: "A29", value: "SDB TT Jammu" },
  { label: "A30", value: "SDB MT Jammu" },
  { label: "A31", value: "Customer Merchant" },
  { label: "A32", value: "AM Logistics" },
  { label: "A33", value: "SDB TT Delhi" },
  { label: "A34", value: "SDB MT Delhi" },
  { label: "A35", value: "Udaan" },
  { label: "A36", value: "SS2" },
  { label: "A37", value: "FSN Distribution" },
  { label: "A38", value: "Big Basket" },
  { label: "A39", value: "SDB MT Bhiwandi D&" },
  { label: "A40", value: "SDB MT Delhi D & R" },
  { label: "A41", value: "MT D & R" },
  { label: "A42", value: "KERALA TT" },
  { label: "A43", value: "KERALA HOSPITAL MT" },
  { label: "A44", value: "KERALA MT" },
  { label: "A45", value: "KERALA MT D & R." },
  { label: "A46", value: "SLP SOUTH KA TT" },
  { label: "A47", value: "SLP SOUTH KA MT" },
  { label: "A48", value: "SLP SOUTH KA MT D&R" },
  { label: "A49", value: "SLP TAMIL NADU TT" },
  { label: "A50", value: "SLP TAMIL NADU MT D&R" },
  { label: "A51", value: "UNDER SDB TT" },
  { label: "A52", value: "UNDER SDB MT" },
  { label: "A53", value: "USS Madurai - MT D&R" },
  { label: "A54", value: "Under SDB SS" },
  { label: "A55", value: "SLP Telangana TT" },
  { label: "A56", value: "SLP Telangana MT D&R" },
  { label: "A57", value: "SLP AP MT D&R" },
  { label: "A58", value: "SLP AP TT" },
  { label: "A59", value: "SLP - West UP TT" },
  { label: "A60", value: "SLP - West UP MT D&R" },
  { label: "A61", value: "West Bengal TT" },
  { label: "A62", value: "West Bengal SS" },
  { label: "A63", value: "North Karnataka TT" },
  { label: "A64", value: "North Karnataka SS" },
];

export const GST_TYPE = {
  ["96190030"]: 5,
  ["96190090"]: 5,
  ["96190010"]: 0,
  ["96190020"]: 0,
  ["33071090"]: 18,
  ["63079090"]: 5,
};

export const CONDITION_TYPE = [
  { label: "Price (ZPO1)", value: "ZP01" },
  { label: "Discount (ZD00)", value: "ZD00" },
];

export const USER_STATUS_OPTIONS = [
  { label: "Active", value: 1 },
  { label: "Deactive", value: 0 },
];

export const PURCHASE_STATUS_OPTIONS = [
  { label: "Pending", value: 1 },
  { label: "Accepted", value: 2 },
  { label: "Rejected", value: 3 },
];
export const RETAILER_INVOICE_STATUS = [
  { label: "Pending Invoices", value: 3 },
  { label: "Generated Invoices", value: 5 },
];

export const ACTION_ICON_SIZE = ".875rem";

export const CREDIT_DAYS = {
  C0: 0,
  C1: 1,
  C3: 3,
  C5: 5,
  C7: 7,
  C8: 8,
  C9: 9,
  C10: 10,
  C12: 12,
  C15: 15,
  C21: 21,
  C24: 24,
  C45: 45,
};

export const PAYMENT_METHODS = [
  { label: "C0 - Immediate payment", value: 0 },
  { label: "C1 - 1 day", value: 1 },
  { label: "C3 - 3 days", value: 3 },
  { label: "C5 - 5 days", value: 5 },
  { label: "C7 - 7 days", value: 7 },
  { label: "C8 - 8 days", value: 8 },
  { label: "C9 - 9 days", value: 9 },
  { label: "C10 - 10 days", value: 10 },
  { label: "C12 - 12 days", value: 12 },
  { label: "C15 - 15 days", value: 15 },
  { label: "C21 - 21 days", value: 21 },
  { label: "C24 - 24 days", value: 24 },
  { label: "C45 - 45 days", value: 45 },
  { label: "LIFEFREE_ONLY_45_DAYS", value: 45.0},
];

export const PURCHASE_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  REJECTED: 3,
};

export const ORDER_STATUS = {
  PENDING: 1,
  CONFIRMED: 2,
  ACCEPTED: 3,
  REJECTED: 4,
  INVOICE_GENERATED: 5,
  INVOICE_CANCELLED: 6,
  INVOICE_RETURNED: 7,
  COMPLETED: 8,
  E_INVOICE_GENERATED: 9,
};

export const STATE_CODE_NAME = {
  1: "JAMMU AND KASHMIR",
  2: "HIMACHAL PRADESH",
  3: "PUNJAB",
  4: "CHANDIGARH",
  5: "UTTARAKHAND",
  6: "HARYANA",
  7: "DELHI",
  8: "RAJASTHAN",
  9: "UTTAR PRADESH",
  10: "BIHAR",
  11: "SIKKIM",
  12: "ARUNACHAL PRADESH",
  13: "NAGALAND",
  14: "MANIPUR",
  15: "MIZORAM",
  16: "TRIPURA",
  17: "MEGHALAYA",
  18: "ASSAM",
  19: "WEST BENGAL",
  20: "JHARKHAND",
  21: "ORISSA",
  22: "CHHATTISGARH",
  23: "MADHYA PRADESH",
  24: "GUJARAT",
  25: "DAMAN AND DIU",
  26: "DADAR AND NAGAR HAVELI",
  27: "MAHARASTRA",
  29: "KARNATAKA",
  30: "GOA",
  31: "LAKSHADWEEP",
  32: "KERALA",
  33: "TAMIL NADU",
  34: "PUDUCHERRY",
  35: "ANDAMAN AND NICOBAR",
  36: "TELANGANA",
  37: "ANDHRA PRADESH",
  97: "OTHER TERRITORY",
  96: "OTHER COUNTRY",
};

export const INVOICE_STATUS = {
  PLACED: 1,
  CANCELLED: 2,
  RETURNED: 3,
};

export const NOTE_TYPE = {
  DEBIT_NOTE: 1,
  CREDIT_NOTE: 2,
};

export const NOTE_TYPE_OPTIONS = [
  { label: "Debit Note", value: 1 },
  { label: "Credit Note", value: 2 },
];

export const ORDER_STATUS_SELECT = [
  { label: "Pending", value: 2 },
  { label: "Rejected", value: 4 },
];

export const ORDER_STATUS_ARRAY = [
  { label: "Pending", value: 1, color: "#FFC107" }, // Amber - Awaiting action
  { label: "Confirmed", value: 2, color: "#0D6EFD" }, // Primary Blue - Official confirmation
  { label: "Accepted", value: 3, color: "#198754" }, // Success Green - Positive state
  { label: "Rejected", value: 4, color: "#DC3545" }, // Danger Red - Denial or failure
  { label: "Invoice Generated", value: 5, color: "#6F42C1" }, // Deep Purple - Documentation step
  { label: "Invoice Cancelled", value: 6, color: "#6C757D" }, // Muted Gray - Cancelled or inactive
  { label: "Partial Returned", value: 7, color: "#FD7E14" }, // Orange - Returned/reversal
  { label: "Completed", value: 8, color: "#20C997" }, // Teal - Finished state
  { label: "E-Invoice Generated", value: 9, color: "#6610f2" }, // Indigo - Digital/integrated process
];

export const PAYMENT_METHODS_SELECT = [
  { label: "Cash", value: 1 },
  { label: "Net Banking", value: 2 },
  { label: "Cheque", value: 3 },
  { label: "UPI", value: 4 },
  { label: "Retailer AR", value: 5 },
  { label: "TDS", value: 9 },
  { label: "Sales", value: 6 },
  { label: "Return", value: 7 },
  { label: "Cancel", value: 8 },
];

export const RETAILER_CLASS = [
  { label: "A", value: 1 },
  { label: "A+", value: 2 },
  { label: "B", value: 3 },
  { label: "B+", value: 4 },
  { label: "C", value: 5 },
];

export const NAVIGATION_ICON = {
  ORDER: <FiPackage />,
  INVOICE: <TbFileInvoice />,
  CROSS_BUTTON: <ImCross />,
  COPY_ICON: <IoMdCopy />,
  MATERIAL: <MdOutlineInventory2 />,
  FILE_UPLOAD: <MdOutlineFileUpload />,
  STORAGE_LOCATIONS: <GrMapLocation />,
  USER: <FaUser />,
  PLANTS: <TbBuildingFactory />,
  STATE_PROJECTION_SUMMARY: <TiMap />,
  BILLING: <FaFile />,
  PAYMENT: <FaWallet />,
};

export const TABLE_ACTION_KEYS = {
  EDIT: "Edit",
  DELETE: "Delete",
  ADD: "Add",
  VIEW: "View",
  RESET: "Reset",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  NAVIGATE: "Navigate",
  DOWNLOAD: "Download",
  IMPORT: "Import",
  CHANGE_PASSWORD: "ChangePassword",
  STATUS: "status",
  VIEW_MORE_INFO: "viewMoreInfo",
  EXPORT: "Export",
  ACTIVITY_LOG: "activityLog",
  HOMESCREEN_VISIBLE: "homeScreenVisibility",
  BLOCK_MOBILE_ORDER: "blockMobileOrder",
};

export const ACTIVE_INACTIVE_STATUS = [
  {
    label: "ACTIVE",
    identifier: 2,
    key: "ACTIVE",
    value: true,
  },
  {
    label: "BLOCKED",
    identifier: 3,
    key: "BLOCKED",
    value: false,
  },
];

export const BILL_TYPE = [
  {
    label: "E-Invoice",
    value: 1,
  },
  {
    label: "E-Way Bill",
    value: 2,
  },
];

export const BILL_CONSTANTS = {
  E_INVOICE: 1,
  E_WAY_BILL: 2,
};

export const TOAST_TIMING = 4000;

export const COMMON_DATE_FORMAT = "DD MMMM YYYY hh:mm A";

export const COMMON_DATE = "DD MMMM YYYY";

export const INITIAL_PAGE_COUNT = 25;

export const NO_DATA_FOUND = "-";

// export const NAME_COLUMN_SIZE = "";

export const USER_MANAGEMNT_COMMON_SEARCH_INFO = "Search by name";

export const USER_MANAGEMNT_ACTION_CONSTANT = [
  { label: "Edit", key: TABLE_ACTION_KEYS.EDIT, toolTip: "Edit" },
];
export const RESET_ACTION_CONSTANT = [
  { label: "Reset", key: TABLE_ACTION_KEYS.RESET, toolTip: "Reset Passowrd" },
];
export const TRANSACTION_OPTION = {
  CREDIT: 1,
  DEBIT: 2,
};
export const TRANSACTION_TYPE = [
  { label: "Credit", value: 1 },
  { label: "Debit", value: 2 },
];
export const PAYMENT_STATUS = [
  { label: "Completed Payments", value: 1 },
  { label: "Partial/Pending Payments", value: 2 },
];

function showLoggedinCustomerGroup() {
  const authData = JSON.parse(localStorage?.getItem("admin")) || null;
  if (authData?.auth) {
    const groups = JSON.parse(authData?.auth)?.user?.materialGroups || []
    return CUSTOMER_GROUP?.filter((item) => groups?.includes(item?.label))
  }
  else return CUSTOMER_GROUP
}

export const FILTER_CONSTANT = {
  isSearch: {
    placeholder: USER_MANAGEMNT_COMMON_SEARCH_INFO,
    toolTipText: USER_MANAGEMNT_COMMON_SEARCH_INFO,
  },
  isCalendarFilter: {
    type: "date-range-picker",
    placeholder: "Select date range",
    filterKey1: "startDate",
    filterKey2: "endDate",
  },

  isResetButton: {
    label: "Reset",
    icon: <GrPowerReset />,
    filterKey: {
      statuses: null,
      startDate: null,
      endDate: null,
      customerGroup: null,
      material: null,
      customer: null,
      plant: null,
      storageLocation: null,
      conditionType: null,
      isUnassigned: false,
      deliveryCode: null,
    },
  },
  isFilterButton: {
    label: "Filter",
    icon: <CiFilter />,
    filters: [
      {
        component: "select",
        options: USER_STATUS_OPTIONS,
        className: "w-full",
        placeholder: "Select Status",
        filterKey: "statuses",
      },
      {
        component: "select",
        options: TRANSACTION_TYPE,
        className: "w-full",
        placeholder: "Select Transaction Type",
        filterKey: "transactionType",
      },
      {
        component: "select",
        options: PAYMENT_STATUS,
        className: "w-full",
        placeholder: "Select Payment Status",
        filterKey: "paymentStatus",
      },
      {
        component: "select",
        options: PURCHASE_STATUS_OPTIONS,
        className: "w-full",
        placeholder: "Select Purchase Status",
        filterKey: "purchaseStatus",
      },
      {
        component: "select",
        options: ORDER_STATUS_SELECT,
        className: "w-full",
        placeholder: "Select Order Status",
        filterKey: "orderStatus",
      },
      {
        component: "select",
        options: BILL_TYPE,
        className: "w-full",
        placeholder: "Select Bill Type",
        filterKey: "billType",
      },
      {
        component: "select",
        options: RETAILER_INVOICE_STATUS,
        className: "w-full",
        placeholder: "Select Status",
        filterKey: "retailerInvoiceStatus",
      },

      {
        component: "select",
        options: CONDITION_TYPE,
        className: "w-full",
        placeholder: "Select Condition Type ",
        filterKey: "conditionType",
      },
      {
        component: "select",
        options: showLoggedinCustomerGroup()?.map((item) => ({
          label: `${item?.value || ""} - ${item?.label || ""}`,
          value: item?.label || "",
        })),
        // options: useLoggedInCustomerGroup(),
        className: "w-full",
        placeholder: "Select Customer Group ",
        filterKey: "customerGroup",
      },
      {
        component: "material-async-select",
        className: "w-full",
        placeholder: "Select Material",
        filterKey: "material",
      },

      {
        component: "retailers-async-select",
        className: "w-full",
        placeholder: "Select Retailer",
        filterKey: "retailers",
      },
      {
        component: "storage-location-async-select",
        className: "w-full",
        placeholder: "Select Storage Location",
        filterKey: "storageLocation",
      },
      {
        component: "sales-officer-async-select",
        className: "w-full",
        placeholder: "Select Sales Person",
        filterKey: "SLPMembers",
      },
      {
        component: "checkbox",
        label: "Select All Purchase",
        className: "w-full",
        filterKey: "checkbox",
      },
    ],
  },
};

export const PAYMENT_REASON = [
  { label: "Sales with Credit Days", value: 1 },
  { label: "Advance Submission", value: 2 },
  { label: "Paid Extra While Payment", value: 3 },
  { label: "Returned/Cancelled Order", value: 4 },
  { label: "Sales with Immediate Payment", value: 5 },
  { label: "Extra While Invoice Generation", value: 6 },
  { label: "Rejected Punched Order", value: 7 },
  { label: "Quantity Update by Distributor", value: 8 },
  { label: "Offset Payment", value: 9 },
  { label: "TDS Payment", value: 11 },
];
